@if (isEditing) {
  <app-events-form
    *ngIf="isEditing"
    [isEditMode]="true"
    [eventId]="event.id"
    (formSubmitted)="onFormUpdated($event)">
  </app-events-form>
} @else {
  <div class="container main-content mt-5 pt-5 col-lg-10 col-md-10 col-12" *ngIf="eventExists;else notLoaded">
    <div class="custom-card-large">
      <div class="card-body d-flex row justify-content-center text-center">
        <div>
          <div class="d-flex justify-content-end">
            <button *ngIf="!event.isDeleted && !isDeleting"
                    class="btn btn-primary delete-btn"
                    (click)="deleteEvent()"
                    style="padding-bottom: 3px;">
              <span class="material-symbols-outlined">
                delete
              </span>
            </button>

            <button *ngIf="event.isDeleted && (teacher?.role?.toLowerCase() === 'admin')"
                    class="btn btn-primary delete-btn"
                    (click)="undeleteEvent()">
              Undelete
            </button>
          </div>
        </div>
        <div *ngIf="eventExists">
          <div *ngIf="event; else noEvent">
            <h5 class="title mb-3">Event Information</h5>
            <div class="row row-cols-4 mb-3">
              <div class="col txt">Event Status:</div>
              <div class="col">{{ event.status }}</div>
              <div class="col txt">Event Start Date:</div>
              <div class="col">{{ event.startDate }}</div>

              <div class="col txt">Event Name:</div>
              <div class="col">{{ event.name }}</div>
              <div class="col txt">Event End Date:</div>
              <div class="col">{{ event.endDate }}</div>
              <div class="col txt">Event Web Link:</div>
              <div class="col">
                <a [href]="event.webLink" target="_blank" rel="noopener">
                  {{ event.webLink }}
                </a>
              </div>
              <div class="col txt">Event Contact Name:</div>
              <div class="col">{{ event.contactName}}</div>
              <div class="col txt">Event Contact Phone Number:</div>
              <div class="col">{{ formatPhone(event.contactPhone) }}</div>
            </div>

            <h5 class="title mb-3">Details</h5>
            <div class="row row-cols-2 mb-3">
              <div class="col txt">Event Description:</div>
              <div class="col txt">Event Commentary:</div>

              <div class="col box">{{ event.description }}</div>
              <div class="col box">{{ event.commentary }}</div>
            </div>

            <h5 class="title mb-3">More Information</h5>
            <div class="row row-cols-4">
              <div class="col txt">Created By:</div>
              <div class="col">{{ event.createdBy }}</div>

              <div class="col txt">Updated By:</div>
              <div class="col">{{ event.updatedBy }}</div>

              <div class="col txt">Created Date:</div>
              <div class="col">{{ event.creationDate | date:'short' }}</div>

              <div class="col txt">Updated Date:</div>
              <div class="col">{{ event.updatedDate | date:'short' }}</div>
            </div>

            <br/>

            <div class="mt-4">
              <div class="d-flex justify-content-center gap-3 flex-column flex-md-row">
                <a routerLink="/events" class="btn btn-primary w-25">Return To List View</a>
                <button class="btn btn-primary w-25" (click)="toggleEditing()" *ngIf="teacher?.role !== 'Teacher'">Edit</button>
              </div>
            </div>
          </div>
        </div>

        <ng-template #noEvent>
          <h4>Loading Event Details...</h4>
        </ng-template>
      </div>
    </div>
  </div>
}

<ng-template #notLoaded>
  <div class="container mt-5 pt-5 col-lg-10 col-me-10 col-12 text-center">
    <div class="custom-card-large">
      <h2>You do not have access to this page.</h2>
    </div>
  </div>
</ng-template>

